import { AuthService } from "@/services/auth.service";
import {CategoryService} from "@/services/category.service";
import {BabyService} from "@/services/baby.service";
import {MilestoneService} from "@/services/milestone.service";
import {UserService} from "@/services/user.service";
import {RecentSearchService} from "@/services/recent-search.service";

const services: any = {
  auth: new AuthService(),
  category: new CategoryService(),
  baby: new BabyService(),
  milestone: new MilestoneService(),
  user: new UserService(),
  recentSearch: new RecentSearchService(),
}

export const ServiceFactory = {
  get: (name: string) => services[name]
}
